<template>
  <LabTechnician v-if="utid == (4 || 3) && !inMobHide" :userInfo="userInfo" />
  <main class="sa-content sa-load-dealy" v-else>
    <template v-if="!loader">
      <div class="sa-mobile-bg sa-h-sm-up">
        <h5 @click="fullImageModal = true">Search Doctors</h5>
        <h4>Book Appointments</h4>
      </div>
      <div class="sa-card-large sa-dash-card">
        <div class="sa-banner">
          <span class="sa-tit">
            Sanar
            <span class="sa-subtit">Manage your appointments</span>
          </span>
          <div class="sa-apps">
            <a href="https://play.google.com/store/apps/details?id=com.sanarcare.pro&hl=en" class="app-store"
              target="_blank"></a>
            <a class="google-store"
              href="https://apps.apple.com/in/app/sanar-%D9%84%D9%84%D8%A3%D8%B7%D8%A8%D8%A7%D8%A1/id1472184380"
              target="_blank"></a>
          </div>
        </div>
        <div class="sa-dash"></div>
        <div class="sa-card sa-disable-me" v-if="utid !== (4 || 3)">
          <div class="sa-row">
            <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6 sa-d-f-a-center sa-h-xs">
              <div class="sa-avtar-bg">
                <figure class="sa-avtar sa-avtar-lg">
                  <img :src="userInfo.img ? userInfo.img : unknownImg" alt="avtar" class="sa-avtar-rotate" />
                </figure>
                <span class="sa-avtar-ico">
                  <i class="icon-time"></i>
                </span>
              </div>
              <h4>
                {{ userInfo.title_nm }} {{ userInfo.fn }} {{ userInfo.ln }}
                <h5 v-if="
                  userInfo &&
                  userInfo.class_nm &&
                  userInfo.class_nm == userInfo.dept_name
                " class="sa-font-normal sa-d-block">
                  {{ userInfo.dept_name }}
                </h5>
                <h5 v-else-if="userInfo && userInfo.class_nm" class="sa-font-normal sa-d-block">
                  {{ userInfo.class_nm }}, {{ userInfo.dept_name }}
                </h5>
                <h5 v-else class="sa-font-normal sa-d-block">
                  {{ userInfo.dept_name }}
                </h5>
              </h4>
            </div>
            <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6 sa-text-right">
              <div class="sa-notific sa-sprite">
                My E-Clinic Status
                <div class="sa-switch">
                  <input type="checkbox" id="notific" :checked="userInfo.disable" @change="disableDoctor"
                    name="notific" />
                  <label for="notific">
                    <span class="sa-input-box"></span>
                  </label>
                </div>
              </div>
              <div v-if="userInfo.disable" class="sa-eclinicstatus sa-eclinic-disable">
                I can receive appointments within
                {{ userInfo.buffer_time }} mins depending on my availability
              </div>
              <div v-else class="sa-eclinicstatus sa-eclinic-enable sa-badge-danger">
                I can not receive any appointments until I reactivate my status
                again
              </div>
            </div>
          </div>
        </div>
        <div class="sa-card sa-card-noshadow sa-gray-bg sa-mb0 sa-mob-no-card">
          <div class="sa-appointments">
            <router-link :to="{ path: `/appointments?stid=${sType}&&app_stat=3` }" class="sa-appoint-link">
              <span class="sa-appoint-box sa-upcoming sa-sprite"></span>
              Upcoming Appointments
            </router-link>
            <router-link :to="{ path: `/appointments?stid=${sType}&&app_stat=4` }" class="sa-appoint-link">
              <span class="sa-appoint-box sa-completed sa-sprite"></span>
              Completed Appointments
            </router-link>
            <router-link to="/schedule" class="sa-appoint-link">
              <span class="sa-appoint-box sa-schedule sa-sprite"></span>
              Scheduled Appointments
            </router-link>
            <router-link to="/profile" class="sa-appoint-link">
              <span class="sa-appoint-box sa-my-profile sa-sprite"></span> My
              Profile
            </router-link>
          </div>
        </div>
        <template v-if="utid !== (4 || 3)">
          <div class="sa-d-f-sbetween sa-mt30">
            <h6>Family Patients</h6>
            <span @click="$router.push('/families')" class="sa-link sa-see-all">See all</span>
          </div>
          <family-patients />
          <div class="sa-text-right sa-mob-card">
            <div class="sa-pub-pro sa-sprite">
              Publish Your Profile
              <div class="sa-switch">
                <input type="checkbox" id="pubPro" />
                <label for="pubPro">
                  <span class="sa-input-box"></span>
                </label>
              </div>
            </div>
          </div>
        </template>
        <div v-if="!loader && userInfo.verified !== 2" class="sa-text-right sa-mob-card">
          <div v-if="userInfo.e_type == 'S'" class="sa-pub-pro sa-sprite">
            {{ userInfo.pub ? "Profile Published" : "Publish you profile" }}
            <div class="sa-switch">
              <input type="checkbox" id="pubPro" :checked="userInfo.pub" :disabled="userInfo.pub" name="pubPro"
                @change="publishProfile" />
              <label for="pubPro">
                <span class="sa-input-box"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="sa-dialog-white">
        <img src="../../assets/img/loader.svg" alt="loader" class="sa-loader" />
      </div>
    </template>
  </main>
</template>
<script>
import { pro_url } from "../../../config/endpoints";
import Notifications from '../../components/settings/Notifications.vue';
import FamilyPatients from '../../components/familydoctors/FamilyPatients.vue';
import LabTechnician from "../lab-technician/LabTechnician.vue";
export default {
  components: { Notifications, FamilyPatients, LabTechnician },
  data() {
    return {
      inMobHide:false,
      loader: false,
      sType: "all",
      userInfo: {},
      unknownImg: "https://img.litedev.com/images/unknown-avtar.png",
    };
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    publishProfile() {
      let _self = this;
      _self.loader = true;
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/publish`,
        })
        .then((response) => {
          if (response && response.status === 1000) {
            _self.userInfo.pub = true;
            _self.$localStorage.set("userdata", JSON.stringify(_self.userInfo));
          } else {
            _self.userInfo.pub = false;
          }
          _self.loader = false;
        })
        .catch((e) => { });
    },
    disableDoctor() {
      let _self = this;
      if (_self.userInfo.disable === false) {
        _self.userInfo.disable = true;
      } else {
        _self.userInfo.disable = false;
      }
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/disable`,
          body: {
            disable: _self.userInfo.disable,
          },
        })
        .then((response) => {
          if (response && response.status === 1000) {
            _self.$localStorage.set("userdata", JSON.stringify(_self.userInfo));
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: response.message,
              class: "sa-a-success",
            });
          } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: response.message,
              class: "sa-a-success",
            });
          }
        })
        .catch((e) => { });
    },
    bufferTime() {
      let _self = this;
      _self.$store
        .dispatch("httpGet", {
          uri: `${pro_url}/bufferTime`,
        })
        .then((response) => {
          if (response && response.status === 1000) {
            _self.userInfo.buffer_time = response.data.buffer_time;
            _self.userInfo.disable = response.data.disable;
            _self.$localStorage.set("userdata", JSON.stringify(_self.userInfo));
          } else {
          }
        })
        .catch((e) => { });
    },
    screenWidth() {
      if (typeof window != 'undefined' && window.innerWidth <= 768) {
        this.inMobHide = false
      } else {
          this.inMobHide = true
      }
    }
  },
  created() {
    let _self = this;
    _self.userInfo = JSON.parse(_self.$localStorage.get("userdata")) || {};
    if (_self.userInfo.e_type == "S") {
      _self.sType = "all";
    }
    this.utid = JSON.parse(this.$localStorage.get("utid"))
  },
  mounted() {
    this.toggleBodyClass("addClass", "sa-dashboard");
    this.bufferTime();
    this.screenWidth()
  },
  destroyed() {
    this.toggleBodyClass("removeClass", "sa-dashboard");
  },
};
</script>
  
